import { useCallback, useEffect, useState } from "react";

import { ViewGroupOption } from "../queueTypes";
import { fetchViewGroups } from "../services/queueService";

/**
 * The groups the user lists under Communications › Groups (View Another Group, KAN-1362), A–Z. None until the
 * user picks some. Asked again on each move within Communications (a deleted group drops out); `setGroups` takes
 * the pop-up's list after Save.
 */
const useViewedGroups = (enabled: boolean, pathname: string) => {
  const [groups, setGroups] = useState<ViewGroupOption[]>([]);
  const inCommunications = pathname.startsWith("/communications");

  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    fetchViewGroups()
      .then((response) => {
        if (active && response.success) setGroups(response.data ?? []);
      })
      .catch(() => undefined); // The menu just keeps what it last knew
    return () => {
      active = false;
    };
    // `inCommunications ? pathname : ""`: refreshed while moving within Communications, not on every page
  }, [enabled, inCommunications ? pathname : ""]); // eslint-disable-line react-hooks/exhaustive-deps

  const update = useCallback((next: ViewGroupOption[]) => setGroups(next), []);

  return { viewedGroups: groups.filter((group) => group.viewing), setGroups: update };
};

export default useViewedGroups;
